import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { DataTransferService } from '../../cat-edit/data-transfer.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { MessageService } from 'primeng/api';
import { PDFDocument, degrees } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import { PdfjsWorkerBootstrapService } from 'src/app/services/pdfjs-worker-bootstrap.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfResizeService, rotateLandscapePageToPortrait } from 'src/app/services/pdf-resize.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { PdfSecurityService } from 'src/app/services/pdfsecurity.service';
import { SafeHtmlService } from 'src/app/services/safe-html.service';
import { CAT_EXECUTION_UPLOAD_CONSTANTS } from 'src/app/models/cat-execution-upload.constant';
import { PdfValidationService } from 'src/app/services/pdf-validation.service';

interface Mime {
  mime: string;
  pattern: (number | undefined)[];
}

const imageMimes: Mime[] = [
  {
    mime: 'application/pdf',
    pattern: [0x25, 0x50, 0x44, 0x46],
  },
];

interface FormField {
  label: string;
  mandatory: boolean;
  data_type: 'text' | 'dropdown' | 'date';
  options?: Record<string, string>[]; // Optional for dropdowns
  module: string;
}

@Component({
    selector: 'app-cat-execution-upload-documents',
    templateUrl: './cat-execution-upload-documents.component.html',
    styleUrls: ['./cat-execution-upload-documents.component.scss'],
    standalone: false
})
export class CatExecutionUploadDocumentsComponent implements OnInit {
  branches: any;
  fileName: any = 'Selected File';
  selectedBranch: any;
  productDetails: FormGroup;
  selectedDocumentType = '';
  pdfSource: any;
  uploadFiles: File[] = [];
  showTemplatePage: boolean = false;
  showUploadPage: boolean = true;
  selectFile: any;
  chooseFile: boolean = false;
  backupUploadFiles: File[] = [];
  previewModalVisible: boolean = false;
  previewFile: File | null = null;
  previewFileName: string = '';
  activePreviewIndex: number = -1;
  previewModalMode: 'upload' | 'preview' = 'preview';
  stagedUploadFiles: File[] = [];
  previewModalFiles: File[] = [];
  popupPreviewPdfSrc: any = null;
  popupPreviewBytes: Uint8Array | null = null;
  popupPreviewPage: number = 1;
  popupPreviewTotalPages: number = 1;
  popupPreviewZoom: number = 1.0;
  hasLandscapePages: boolean = false;
  isRotating: boolean = false;
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  @ViewChild('uploadSuccessModal') uploadSuccessModal!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('pdfCanvas') pdfCanvas?: ElementRef<HTMLCanvasElement>;
  private pdfjsWorkerBootstrap = inject(PdfjsWorkerBootstrapService);
  isRenderingPdf: boolean = false;
  pdfRenderError: boolean = false;
  private loadedPdfDoc: any = null;
  @ViewChild('uploadDocSuccessModalPopup')
  uploadDocSuccessModalPopup!: ElementRef;

  isDragOver = false;

  // Cloud import Declarations
  showGoogleDriveModal = false;
  showDropboxModal = false;
  showOneDriveModal = false;
  visible: boolean = false;
  showLinkModal: boolean = false;
  pdfUrl = '';
  downloadingFromUrl = false;

  @Input() uploadDocumentsData: any = [];
  @Output() productDetailsChange: EventEmitter<any> = new EventEmitter<[]>();
  isDocUploaded: boolean = false;
  selectedValue: any;
  showFileName: boolean = false;
  base64Doc: any;
  valueChanged: EventEmitter<string> = new EventEmitter<string>();
  submitted: boolean = false;
  enableRefIdField: boolean;
  totalPages: number;
  mergedPages: number = 0;
  pageHeight: number[];
  base64Data: string;
  pageWidth: number[];
  noBranch: boolean = false;
  fileURL: string;
  showHdfcFields: boolean = true;
  organisationId: any;
  isDocsFileAllowed: any;
  showDocs: boolean;
  // isDocumentType: string = '';
  contractType: boolean = false;
  showFields: boolean = false;
  dynamicForm: FormGroup;
  formData: any = [];
  filteredValues: any;
  selectednValue: string = '';
  savedData: any = {};
  isEStampEnabled: boolean = false;
  documentPayload: any;
  isDocumentType: string = '003';
  fileSizeError: boolean;
  // Add these properties to your component class
  signatureError: boolean = false;
  signatureErrorMessage: string = '';
  isContractExpiryDate: boolean = false;
  minExpiryDate: Date;
  today: Date;
  account_id: any;
  securityError: boolean = false;
  safePreviewContent: string = '';
  isEditorVisible: boolean = false;
  currentPdfToEdit: string = '';
  currentFileName: string = '';

  get dropboxEnabled(): boolean {
    return this.storageService?.getDropBoxEnabled() || false;
  }

  get isEditPdfEnabled(): boolean {
    return !!this.storageService?.getEditPdf();
  }
  referenceIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const validPattern = /^[a-zA-Z0-9_-]*$/;
      return validPattern.test(value) ? null : { invalidChars: true };
    };
  }
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private storageService: StorageService,
    private dataTransferService: DataTransferService,
    private catUploadService: CatUploadService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private pdfResizeService: PdfResizeService,
    private userProfileService: UserProfileService,
    private pdfSecurityService: PdfSecurityService,
    private safeHtmlService: SafeHtmlService,
    private pdfValidationService: PdfValidationService,
    private cdr: ChangeDetectorRef
  ) {
    this.dynamicForm = this.formBuilder.group({});

    this.productDetails = this.formBuilder.group({
      branchName: ['Selected Branch', [Validators.required]],
      referenceNumber: ['', [Validators.maxLength(80),Validators.required,this.referenceIdValidator()]],
      expiry_date: [
        null,
        this.isContractExpiryDate ? [Validators.required] : [],
      ],
      isEStampEnabled: [false],
    });
    this.organisationId = this.storageService.getOrganization() || '';
    this.showHdfcFields = this.organisationId === 'HDHO';
    this.account_id = this.storageService.getAccountId() || null;
  }
 
  ngOnInit(): void {
    const today = new Date();
    this.minExpiryDate = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    );
    this.savedData = this.catUploadService.getFormData();
    this.isDocumentType = '003';
    if (this.savedData) {
      this.isDocumentType = this.savedData['isDocumentType'];
      this.onDocumentType({ value: this.isDocumentType });
    }
    this.storageService.setContractType(false);
    this.storageService.setDocumentType(this.isDocumentType);

    if (this.uploadDocumentsData !== undefined) {
      this.uploadFiles = this.uploadDocumentsData.uploadFile;
      this.fileName = this.uploadDocumentsData.fileName;
      this.uploadDocumentsData.base64Doc
        ? (this.base64Data = this.uploadDocumentsData.base64Doc)
        : (this.base64Data = this.uploadDocumentsData.file);
      this.showFileName = true;
    } else {
      this.showFileName = false;
    }
    this.getRefIdConsent();
    this.setSelectedBranchValue();
    this.isDocsFileAllowed = this.storageService.getUploadDocxFile();
    if (this.isDocsFileAllowed) {
      this.showDocs = true;
    } else {
      this.showDocs = false;
    }
    this.getUserSettingDetails();
  }

  clearSelection() {
    this.isDocumentType = '003';
    this.contractType = false;
    this.storageService.setDocumentType(this.isDocumentType);
    this.storageService.setContractNumbere(this.isDocumentType);
    this.storageService.setContractType(false);
    this.formData = [];
    this.dynamicForm = this.formBuilder.group({});
  }

  async getUserSettingDetails() {
    try {
      const res = await this.userProfileService
        .getOrderReviewConsent(this.account_id)
        .toPromise();
      this.isContractExpiryDate =
        res['content']['contract_expiry_mail_trigger'];
      const stampSign =
        res['content']?.additional_configuration?.stamp_sign ??
        res['content']?.stamp_sign ??
        false;
      this.storageService.setStampSignatory(stampSign);
    } catch (error) {
      console.error('Error getting user settings:', error);
      this.isContractExpiryDate = false;
    }
  }

  getExpiryDate(): Date | null {
    try {
      if (!this.isContractExpiryDate) return null;

      const expiryDateControl = this.productDetails.get('expiry_date');
      console.log('<=====================>', expiryDateControl);

      if (!expiryDateControl) {
        console.error('Expiry date control not found');
        return null;
      }

      const expiryDate = expiryDateControl.value;
      if (!expiryDate) {
        return null;
      }
      return expiryDate;
    } catch (error) {
      console.error('Error getting expiry date:', error);
      return null;
    }
  }

  onDocumentType(event: any) {
    if (!['001', '002'].includes(String(event?.value || ''))) {
      this.clearSelection();
      return;
    }
    this.submitted = false;
    this.dynamicForm.reset();
    this.selectedValue = event.value;
    this.showFields = false;
    this.isDocumentType = event.value;
    this.dynamicForm = this.formBuilder.group({});
    this.storageService.setContractNumbere(this.isDocumentType);
    this.storageService.setDocumentType(this.isDocumentType);

    if (event.value) {
      this.contractType = true;

      this.catUploadService
        .getAddionalFieldDetails(event.value, this.account_id)
        .subscribe((res) => {
          if (res['content'] && Object.keys(res['content']).length > 0) {
            this.formData = res['content'];
            this.createForm();
            const registrationControl =
              this.dynamicForm.get('Registration_Type');
            if (registrationControl) {
              if (this.isDocumentType === '001') {
                const value = this.savedData?.['registration_type'] || 'IND';
                registrationControl.setValue(value);
                // registrationControl.disable();
              } else if (this.isDocumentType === '002') {
                const value = this.savedData?.['registration_type'] || 'IND';
                registrationControl.setValue(value);
              }
            }
          } else {
            this.contractType = false;
          }
          this.storageService.setContractType(this.contractType);
          this.cdr.detectChanges();
        });
    } else {
      this.contractType = false;
      this.storageService.setContractType(this.contractType);
    }
  }

  onRegistrationTypeChange(event: any) {
    if (event.target.value === 'ENT') {
      Object.keys(this.dynamicForm.controls).forEach((key) => {
        if (key !== 'Registration_Type') {
          this.dynamicForm.get(key)?.reset();
        }
      });
      const constitutionControl = this.dynamicForm.get('CONSTITUTION');
      if (constitutionControl) {
        constitutionControl.setValue('');
      }
    }
  }

  createForm() {
    this.formData.forEach((item: any) => {
      const key = Object.keys(item)[0];
      const field = item[key];
      const value = this.savedData?.[key.toLowerCase()] || '';

      if (field.module === 'general') {
        var validators = [];
        this.showFields = true;

        if (key === 'EMAIL_ID') validators.push(Validators.email);
        if (field.mandatory) validators.push(Validators.required);
        const control = new FormControl(value, validators);
        this.dynamicForm.addControl(key, control);
      }
    });
  }

  isNumberField(validators: any[]): boolean {
    return validators?.includes('number');
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getOptionKey(option: Record<string, string>): string {
    return Object.keys(option)[0];
  }

  getOptionValue(option: Record<string, string>): string {
    return Object.values(option)[0];
  }

  onInputChange(event: Event, key: string): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;

    if (key === 'EMAIL_ID') {
      this.dynamicForm.get(key)?.setValue(inputValue);
      return;
    }

    if (key === 'rate_of_interest') {
      const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');
      if (sanitizedValue.length > 5) {
        input.value = sanitizedValue.slice(0, 5);
      } else {
        input.value = sanitizedValue;
      }
      this.dynamicForm.get(key)?.setValue(input.value);
      return;
    }

    if (key === 'CONTACT_NUMBER') {
      const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
      if (sanitizedValue.length > 10) {
        input.value = sanitizedValue.slice(0, 10);
      } else {
        input.value = sanitizedValue;
      }
      this.dynamicForm.get(key)?.setValue(input.value);
      return;
    }

    const isNumberKey = this.isNumberInput(key);

    if (isNumberKey) {
      if (isNaN(Number(inputValue)) || Number(inputValue) < 0) {
        input.value = '';
        this.dynamicForm.get(key)?.setValue('');
      } else {
        this.dynamicForm.get(key)?.setValue(Number(inputValue));
      }
    } else {
      const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');
      input.value = sanitizedValue;
      this.dynamicForm.get(key)?.setValue(sanitizedValue);
    }
  }

  isNumberInput(key: any): boolean {
    const fieldMetadata = key;
    return fieldMetadata?.type === 'number';
  }

  //---------------------------------------------------------------------------------------//

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uploadDocumentsData.currentValue) {
      const data = changes.uploadDocumentsData.currentValue;
      if (data) {
        this.productDetails.controls['branchName'].setValue(data.name);
        this.noBranch = false;
      }
    }
  }

  generateReferenceId() {
    this.catUploadService.getOrValidateReferenceId().subscribe(
      (res: any) => {
        if (res.status === 200) {
          //this.messageService.add({ severity: 'success', detail: res.message });
          this.productDetails.controls['referenceNumber'].setValue(
            res.content.reference_id
          );
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      }
    );
  }

  getRefIdConsent() {
    let refIdConsent = this.storageService.getRefIdConsent() || null;
    if (refIdConsent === true) this.enableRefIdField = true;
    else {
      this.enableRefIdField = false;
      this.generateReferenceId();
    }
  }

  validateReferenceId() {
    let enteredReferenceId = this.productDetails.value.referenceNumber;
    this.catUploadService
      .getOrValidateReferenceId(enteredReferenceId)
      .subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.onSendProductDetails();
          }
        },
        (err) => {
          if (
            'error' in err &&
            'content' in err.error &&
            'errors' in err.error.content
          ) {
            this.messageService.add({
              severity: 'error',
              detail: err.error.message,
            });
          }
        }
      );
  }

  setSelectedBranchValue() {
    this.selectedValue = this.storageService.getBranch() || null;
    this.productDetails.controls['branchName'].setValue(
      this.selectedValue.name
    );
    this.storageService.branchChange.subscribe((branch: any) => {
      this.selectedBranch = branch;
      this.productDetails.controls['branchName'].setValue(branch.name);
    });
  }

  async onFileChange(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;
    const fileArray: File[] = Array.from(files) as File[];
    await this.processFiles(null, fileArray);
  }
  async onEStampToggle(event: any) {
    this.isEStampEnabled = event.target.checked;
  }

  async initPopupPreview(file: File) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      this.popupPreviewBytes = new Uint8Array(arrayBuffer);
      this.loadedPdfDoc = null;
      this.popupPreviewPage = 1;
      this.popupPreviewZoom = 1.0;
      await this.analyzePopupLandscape(this.popupPreviewBytes);
      this.cdr.detectChanges();
      setTimeout(() => this.renderCanvasPage(1), 60);
    } catch (err) {
      console.error('Failed to init popup preview:', err);
    }
  }

  async renderCanvasPage(targetPage: number = this.popupPreviewPage): Promise<void> {
    if (!this.popupPreviewBytes) return;
    this.isRenderingPdf = true;
    this.pdfRenderError = false;
    this.cdr.detectChanges();

    try {
      await this.pdfjsWorkerBootstrap.ready;
      if (!this.loadedPdfDoc) {
        this.loadedPdfDoc = await pdfjsLib.getDocument({ data: this.popupPreviewBytes }).promise;
        this.popupPreviewTotalPages = this.loadedPdfDoc.numPages;
      }

      if (!this.pdfCanvas?.nativeElement) {
        await new Promise((resolve) => setTimeout(resolve, 60));
      }

      const canvas = this.pdfCanvas?.nativeElement;
      if (!canvas) return;

      const page = await this.loadedPdfDoc.getPage(targetPage);
      const unscaledViewport = page.getViewport({ scale: 1 });

      const targetWidth = 560 * (this.popupPreviewZoom || 1.0);
      const dpr = window.devicePixelRatio || 1;
      const scale = (targetWidth * dpr) / unscaledViewport.width;

      const viewport = page.getViewport({ scale });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.style.width = `${Math.round(viewport.width / dpr)}px`;
      canvas.style.height = `${Math.round(viewport.height / dpr)}px`;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        await page.render({ canvasContext: ctx, viewport }).promise;
      }
    } catch (err) {
      console.error('Error rendering PDF page on canvas:', err);
      this.pdfRenderError = true;
    } finally {
      this.isRenderingPdf = false;
      this.cdr.detectChanges();
    }
  }

  private async analyzePopupLandscape(bytes: Uint8Array) {
    try {
      const pdfDoc = await PDFDocument.load(bytes);
      const pages = pdfDoc.getPages();
      this.popupPreviewTotalPages = pages.length;
      let foundLandscape = false;
      for (const page of pages) {
        const { width, height } = page.getSize();
        const rot = page.getRotation().angle;
        const isSwapped = rot === 90 || rot === 270;
        const effW = isSwapped ? height : width;
        const effH = isSwapped ? width : height;
        if (effW > effH) {
          foundLandscape = true;
          break;
        }
      }
      this.hasLandscapePages = foundLandscape;
    } catch (err) {
      this.hasLandscapePages = false;
    }
  }

  private updatePopupPreviewSource() {
    if (!this.popupPreviewBytes) return;
    this.cleanupPopupPreview();
    const blob = new Blob([this.popupPreviewBytes as any], { type: 'application/pdf' });
    this.popupPreviewPdfSrc = URL.createObjectURL(blob);
  }

  cleanupPopupPreview() {
    if (this.popupPreviewPdfSrc && typeof this.popupPreviewPdfSrc === 'string' && this.popupPreviewPdfSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.popupPreviewPdfSrc);
      this.popupPreviewPdfSrc = null;
    }
  }

  togglePopupZoom() {
    this.popupPreviewZoom = this.popupPreviewZoom === 1.0 ? 1.25 : this.popupPreviewZoom === 1.25 ? 1.5 : 1.0;
    this.renderCanvasPage(this.popupPreviewPage);
  }

  async rotatePopupLandscape() {
    if (!this.hasLandscapePages || !this.popupPreviewBytes || this.isRotating) return;
    this.isRotating = true;
    try {
      const pdfDoc = await PDFDocument.load(this.popupPreviewBytes);
      const pages = pdfDoc.getPages();
      let anyRotated = false;
      pages.forEach((page) => {
        const rotated = rotateLandscapePageToPortrait(page, pdfDoc);
        if (rotated) {
          anyRotated = true;
        }
      });
      if (anyRotated) {
        this.popupPreviewBytes = await pdfDoc.save();
        this.loadedPdfDoc = null;
        await this.analyzePopupLandscape(this.popupPreviewBytes);
        await this.renderCanvasPage(this.popupPreviewPage);
        if (this.uploadFiles.length > 0) {
          const updatedFile = new File([this.popupPreviewBytes as any], this.uploadFiles[0].name, {
            type: 'application/pdf',
            lastModified: Date.now()
          });
          this.uploadFiles[0] = updatedFile;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Rotated',
          detail: 'Landscape pages rotated to portrait.'
        });
      }
    } catch (error) {
      console.error('Error rotating popup PDF:', error);
    } finally {
      this.isRotating = false;
      this.cdr.detectChanges();
    }
  }

  triggerChangeFile() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
      this.fileInput.nativeElement.click();
    }
  }

  prevPopupPage() {
    if (this.popupPreviewPage > 1) {
      this.popupPreviewPage--;
      this.renderCanvasPage(this.popupPreviewPage);
    }
  }

  nextPopupPage() {
    if (this.popupPreviewPage < this.popupPreviewTotalPages) {
      this.popupPreviewPage++;
      this.renderCanvasPage(this.popupPreviewPage);
    }
  }

  onPopupPdfLoaded(pdfInfo: any) {
    if (pdfInfo && pdfInfo.numPages) {
      this.popupPreviewTotalPages = pdfInfo.numPages;
    }
    this.cdr.detectChanges();
  }

  previewUploadedFile(index?: number) {
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.previewModalMode = 'preview';
      if (typeof index === 'number' && index >= 0 && index < this.uploadFiles.length) {
        // Badge click — preview this specific file individually
        this.activePreviewIndex = index;
        this.previewFile = this.uploadFiles[index];
        this.previewModalFiles = [this.uploadFiles[index]];
        this.previewFileName = this.uploadFiles[index].name;
      } else if (this.uploadFiles.length > 1) {
        // Eye icon click — show all files merged, individual names as title
        this.activePreviewIndex = -1;
        this.previewFile = null;
        this.previewModalFiles = [...this.uploadFiles];
        this.previewFileName = this.uploadFiles.map(f => f.name).join(', ');
      } else {
        // Single file
        this.activePreviewIndex = 0;
        this.previewFile = this.uploadFiles[0];
        this.previewModalFiles = [this.uploadFiles[0]];
        this.previewFileName = this.uploadFiles[0].name;
      }
      this.previewModalVisible = true;
      this.cdr.detectChanges();
    }
  }

  onUploadConfirmed(event: { file: File; files?: File[]; base64?: string; arrayBuffer?: ArrayBuffer }) {
    const finalFiles = event.files && event.files.length > 0 ? event.files : (this.stagedUploadFiles.length > 0 ? this.stagedUploadFiles : (event.file ? [event.file] : []));
    const finalFile = event.file || finalFiles[0];
    if (finalFile) {
      const incomingFiles = finalFiles.length > 0 ? finalFiles : [finalFile];

      if (!this.uploadFiles || this.uploadFiles.length === 0) {
        this.uploadFiles = [...incomingFiles];
      } else {
        for (const newFile of incomingFiles) {
          const existingIdx = this.uploadFiles.findIndex((f) => f.name === newFile.name);
          if (existingIdx !== -1) {
            this.uploadFiles[existingIdx] = newFile;
          } else {
            this.uploadFiles.push(newFile);
          }
        }
      }

      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
      this.chooseFile = false;

      this.storageService.setfiletype('pdf');

      const count = incomingFiles.length || 1;
      this.messageService.add({
        severity: 'success',
        summary: count === 1 ? 'File Uploaded' : 'Files Uploaded',
        detail: count === 1 ? `${finalFile.name} uploaded successfully` : `${count} files uploaded successfully`,
        life: 3000,
      });
    }
    this.stagedUploadFiles = [];
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onUploadCancelled() {
    this.stagedUploadFiles = [];
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onPreviewFileSaved(event: { file: File; files?: File[] }) {
    if (event.files && event.files.length > 1) {
      // Multi-file save: replace each file in uploadFiles by name
      for (const updatedFile of event.files) {
        const idx = this.uploadFiles.findIndex(f => f.name === updatedFile.name);
        if (idx !== -1) {
          this.uploadFiles[idx] = updatedFile;
        }
      }
      this.activePreviewIndex = -1;
      this.previewFile = null;
      this.previewModalFiles = [...event.files];
      this.previewFileName = this.uploadFiles.map(f => f.name).join(', ');
    } else {
      let idx = this.activePreviewIndex;
      if (idx < 0 || idx >= this.uploadFiles.length) {
        idx = this.uploadFiles.findIndex((f) => f.name === event.file.name);
      }
      if (idx !== -1 && this.uploadFiles[idx]) {
        this.uploadFiles[idx] = event.file;
      } else {
        this.uploadFiles.push(event.file);
      }
      this.previewFile = event.file;
      this.previewFileName = event.file.name;
    }
    this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
    this.cdr.detectChanges();
  }

  async editFile() {
  if (!this.showFileName || this.uploadFiles.length === 0) {
    this.showError('No Files', 'Please select a file to edit', 'warn');
    return;
  }

  try {
    let finalBase64: string;
    let finalFileName: string;

    if (this.uploadFiles.length > 1) {
      this.messageService.add({ severity: 'info', summary: 'Merging', detail: 'Preparing documents...' });

      const mergedPdf = await PDFDocument.create();
      for (const file of this.uploadFiles) {
        const fileArrayBuffer = await file.arrayBuffer();
        const pdf = await PDFDocument.load(fileArrayBuffer);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }
      finalBase64 = await mergedPdf.saveAsBase64({ dataUri: true });
      finalFileName = "Merged_Documents.pdf";
    } else {
      const file = this.uploadFiles[0];
      finalBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => resolve(e.target.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });
      finalFileName = file.name;
    }

    this.isEditorVisible = true;
    this.currentPdfToEdit = finalBase64;
    this.currentFileName = finalFileName;

  } catch (error) {
    console.error('File Preparation Error:', error);
    this.showError('Error', 'Could not prepare file for editing', 'error');
  }
}

  /**
   * Handles the output from the PDF Editor
   */
   handleFinalUpload(modifiedBase64: string) {
     this.isEditorVisible = false;
   
     const base64Data = modifiedBase64.split(',')[1];
     const byteCharacters = atob(base64Data);
     const byteNumbers = new Uint8Array(byteCharacters.length);
   
     for (let i = 0; i < byteCharacters.length; i++) {
       byteNumbers[i] = byteCharacters.charCodeAt(i);
     }

     const blob = new Blob([byteNumbers], { type: 'application/pdf' });
     const editedFile = new File([blob], this.currentFileName || "final_edited_document.pdf", {
       type: 'application/pdf',
     });

     // Critical: Overwrite the uploadFiles array with the new edited version
     this.uploadFiles = [editedFile];

     this.messageService.add({
       severity: 'success',
       summary: 'Document Saved',
       detail: 'Changes applied successfully.',
     });

     // Automatically trigger the validation and upload flow
     this.uploadSelFile();
   }

  async uploadSelFile() {
    if (!this.showFileName || this.uploadFiles.length === 0) {
      this.chooseFile = true;
      this.showError('No Files', 'Please select a file to upload', 'warn');
      return;
    }

    // Final security check before upload
    try {
      const finalValidation = await Promise.all(
        this.uploadFiles.map((file) =>
          this.pdfSecurityService.validateAndSanitizePDF(file)
        )
      );

      const hasInvalidFiles = finalValidation.some((result) => !result.isValid);

      if (hasInvalidFiles) {
        this.showError(
          'Upload Blocked',
          'Security validation failed. Please select different files.',
          'error'
        );
        return;
      }

      this.chooseFile = false;
      this.closeUploadPopupBtn.nativeElement.click();

      // Immediately display Document Preview modal for newly uploaded document
      setTimeout(() => {
        this.previewUploadedFile();
        this.cdr.detectChanges();
      }, 400);

      // Proceed with actual upload
      // Add your upload logic here
    } catch (error) {
      console.error('Upload error:', error);
      this.showError(
        'Upload Failed',
        'An error occurred during upload. Please try again.',
        'error'
      );
    }
  }

  private showError(summary: string, detail: string, severity: string) {
    this.messageService.add({ severity, summary, detail, life: 5000 });
  }

  removeFileName(index: number) {
    this.uploadFiles.splice(index, 1);
    if (this.uploadFiles.length === 0) {
      this.showFileName = false;
      this.fileName = '';
    } else {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
    }
  }

  async proceedWithMerging(data: any) {
    this.spinner.show();
    this.submitted = true;

    if (this.uploadFiles.length === 0) {
      this.spinner.hide();
      return;
    }

    try {
      if (this.uploadFiles.length === 1) {
        const file = this.uploadFiles[0];

        // Validate file
        let splitName = file.name.split('.');
        if (splitName[splitName.length - 1] !== 'pdf') {
          alert(CAT_EXECUTION_UPLOAD_CONSTANTS.NOT_VALID_PDF);
          this.spinner.hide();
          return;
        } else if (splitName.length > 2) {
          alert(CAT_EXECUTION_UPLOAD_CONSTANTS.SINGLE_EXTENSION_REQUIRED);
          this.spinner.hide();
          return;
        }

        // Always convert to A4 for consistency (lossless — vector copy, no rasterization)
        const a4ConvertedFile = (await Promise.race([
          this.pdfResizeService.convertSingleFileToA4(file),
          new Promise((_, reject) =>
            setTimeout(
              () =>
                reject(new Error(CAT_EXECUTION_UPLOAD_CONSTANTS.TIMEOUT_ERROR)),
              CAT_EXECUTION_UPLOAD_CONSTANTS.TIMEOUT_DURATION_MS
            )
          ),
        ])) as File;

        // Read the converted file's bytes ONCE and reuse the same buffer for
        // both page-info extraction and Base64 encoding, instead of reading
        // the file twice (previously: readAsArrayBuffer + readAsDataURL).
        this.uploadFiles[0] = a4ConvertedFile;
        const arrayBuffer = await a4ConvertedFile.arrayBuffer();
        await this.extractPdfInfoOnly(arrayBuffer);

        const base64String =
          this.pdfResizeService.arrayBufferToBase64(arrayBuffer);
        this.base64Data = `data:application/pdf;base64,${base64String}`;

        // Validate Base64 size using service
        if (
          !this.pdfValidationService.validateBase64String(
            this.base64Data,
            file.name
          )
        ) {
          this.spinner.hide();
          return;
        }
      } else {
        // Multiple files - merge them
        const mergedPdf = await PDFDocument.create();

        // Reset arrays
        this.pageHeight = [];
        this.pageWidth = [];
        this.mergedPages = 0;

        for (let i = 0; i < this.uploadFiles.length; i++) {
          const file = this.uploadFiles[i];
          // Validate file
          let splitName = file.name.split('.');
          if (splitName[splitName.length - 1] !== 'pdf') {
            alert(CAT_EXECUTION_UPLOAD_CONSTANTS.NOT_VALID_PDF);
            this.spinner.hide();
            return;
          } else if (splitName.length > 2) {
            alert(CAT_EXECUTION_UPLOAD_CONSTANTS.SINGLE_EXTENSION_REQUIRED);
            this.spinner.hide();
            return;
          }

          // Always convert to A4 for consistency (lossless — vector copy, no rasterization)
          const a4ConvertedFile =
            await this.pdfResizeService.convertSingleFileToA4(file);
          this.uploadFiles[i] = a4ConvertedFile;

          await this.readAndMergePdf(a4ConvertedFile, mergedPdf);
        }

        // Save merged PDF with available optimization options
        const mergedPdfBytes = await mergedPdf.save({
          useObjectStreams: true,
          updateFieldAppearances: false,
        });

        // Convert to base64
        this.base64Data = this.pdfResizeService.arrayBufferToBase64(
          mergedPdfBytes.buffer as ArrayBuffer
        );

        // Validate merged PDF base64 size using service
        if (
          !this.pdfValidationService.validateBase64String(
            this.base64Data,
            'Merged PDF'
          )
        ) {
          this.spinner.hide();
          return;
        }
      }

      this.dataTransferService.setPdfData(this.base64Data);
      this.spinner.hide();
      this.validateReferenceId();
    } catch (error) {
      console.error('Error processing PDF:', error);
      this.messageService.add({
        severity: CAT_EXECUTION_UPLOAD_CONSTANTS.SEVERITY_ERROR,
        detail: CAT_EXECUTION_UPLOAD_CONSTANTS.PDF_PROCESSING_ERROR,
      });
      this.spinner.hide();
    }
  }

  async readAndMergePdf(file: File, mergedPdf: PDFDocument): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const pdfDoc = await PDFDocument.load(reader.result as ArrayBuffer);
          const totalPages = pdfDoc.getPageCount();

          console.log(`Processing PDF with ${totalPages} pages`);

          // Initialize arrays if they don't exist
          if (!this.pageHeight) this.pageHeight = [];
          if (!this.pageWidth) this.pageWidth = [];

          for (let i = 0; i < totalPages; i++) {
            const page = pdfDoc.getPage(i);
            const pageHeight = Math.round(page.getHeight());
            const pageWidth = Math.round(page.getWidth());

            console.log(
              `Page ${i + 1}: Height = ${pageHeight}, Width = ${pageWidth}`
            );

            this.pageHeight.push(pageHeight);
            this.pageWidth.push(pageWidth);
          }

          this.mergedPages += totalPages;

          const copiedPages = await mergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));

          resolve();
        } catch (error) {
          console.error('PDF processing error:', error);
          reject(error);
        }
      };
      reader.onerror = (error) => {
        console.error('File reader error:', error);
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  //---------------------------------------------------------------------------------------------------------------//

  orderDownload(pdfURL: string) {
    const link = document.createElement('a');
    link.href = pdfURL;
    link.download = 'merged_file.pdf'; // Provide a default name for the downloaded file
    link.click();
  }

  isMime(bytes: Uint8Array, mime: Mime): boolean {
    return mime.pattern.every((p, i) => !p || bytes[i] === p);
  }

  validateImageMimeType(file: File, callback: (b: boolean) => void) {
    const numBytesNeeded = Math.max(...imageMimes.map((m) => m.pattern.length));
    const blob = file.slice(0, numBytesNeeded);

    const fileReader = new FileReader();

    fileReader.onloadend = (e) => {
      if (!e || !fileReader.result) return;

      const bytes = new Uint8Array(fileReader.result as ArrayBuffer);

      const valid = imageMimes.some((mime) => this.isMime(bytes, mime));

      callback(valid);
    };

    fileReader.readAsArrayBuffer(blob);
  }

  private formatDateToYYYYMMDD(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  gotoTemplatePage() {
    this.submitted = true;

    if (this.productDetails.invalid) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fix the errors in the form before proceeding',
      });
      return; 
    }

    if (
      this.isContractExpiryDate &&
      !this.productDetails.get('expiry_date')?.value
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please select a valid contract expiry date',
      });
      return;
    }

    console.log(
      'Expiry date value:',
      this.productDetails.get('expiry_date')?.value
    );

    if (this.contractType) {
      const registrationType = this.dynamicForm.get('Registration_Type')?.value;

      // Skip validation if registration type is "IND"
      if (registrationType !== 'IND' && this.dynamicForm.invalid) {
        this.messageService.add({
          severity: 'warn',
          detail: 'Please add the additional Document Details to proceed',
        });
        return;
      }
    }

    if (this.productDetails.value.branchName === 'Selected Branch') {
      this.noBranch = true;
      this.messageService.add({
        severity: 'warn',
        detail: 'Please select state and branch to proceed',
      });
      return;
    }

    if (
      this.uploadFiles === undefined ||
      this.productDetails.value.referenceNumber === ''
    ) {
      return;
    } else {
      // Convert keys to snake_case properly
      const formData = this.dynamicForm.value;
      const convertedData = Object.fromEntries(
        Object.entries(formData).map(([key, value]) => {
          const snakeCaseKey = key
            .replace(/([a-z])([A-Z])/g, '$1_$2')
            .toLowerCase();
          return [snakeCaseKey, value];
        })
      );
      console.log('Converted Form Data:', convertedData);
      convertedData['isDocumentType'] = this.isDocumentType;
      this.catUploadService.setFormData(convertedData);
      this.proceedWithMerging(convertedData);
    }
  }

  onSendProductDetails() {
    this.uploadDocumentsData = this.productDetails.value;
    if (this.isContractExpiryDate) {
      this.uploadDocumentsData.expiryDate = this.formatDateToYYYYMMDD(
        this.productDetails.get('expiry_date')?.value
          ? this.productDetails.get('expiry_date')?.value
          : null
      );
    }
    this.uploadDocumentsData.file = this.base64Data;
    this.uploadDocumentsData.base64Doc = this.base64Data;
    if (this.isEStampEnabled) {
      this.uploadDocumentsData.file = this.documentPayload;
      this.uploadDocumentsData.base64Doc = this.documentPayload;
    }
    // this.uploadDocumentsData.file = this.base64Data;
    this.uploadDocumentsData.fileName = this.fileName;
    this.uploadDocumentsData.totalPages = this.mergedPages;
    this.uploadDocumentsData.pageHeight = this.pageHeight;
    this.uploadDocumentsData.pageWidth = this.pageWidth;
    //this.uploadDocumentsData.base64Doc = this.base64Data.split(',')[1];
    // this.uploadDocumentsData.base64Doc = this.base64Data;
    this.uploadDocumentsData.uploadFile = this.uploadFiles;
    if (this.contractType) {
      this.filteredValues = this.dynamicForm.value;
      this.uploadDocumentsData.estampAddinialDetails = this.filteredValues;

      const formData = this.dynamicForm.value;
      const convertedData = Object.fromEntries(
        Object.entries(formData).map(([key, value]) => {
          const snakeCaseKey = key
            .replace(/([a-z])([A-Z])/g, '$1_$2')
            .toLowerCase();
          return [snakeCaseKey, value];
        })
      );
      this.uploadDocumentsData.estampAddinialDetails = convertedData;
    }

    this.productDetailsChange.emit(this.uploadDocumentsData);
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  openUploadModal() {
    this.backupUploadFiles = [...this.uploadFiles];
    this.chooseFile = false;
    this.fileSizeError = false;
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
    }
    const inputElement = document.getElementById('upload_file') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
  }

  cancelUpload() {
    this.closeUploadPopupBtn.nativeElement.click();
    this.fileSizeError = false;
    if (this.backupUploadFiles && this.backupUploadFiles.length > 0) {
      this.uploadFiles = [...this.backupUploadFiles];
    }
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
    } else {
      this.uploadFiles = [];
      this.fileName = '';
      this.showFileName = false;
    }
    this.backupUploadFiles = [];
  }

  clearFile() {
    this.uploadFiles = [];
    this.fileSizeError = false;
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    inputElement.value = null;
  }

  hasVisibleFields(item: any): boolean {
    return Object.keys(item).some((key) => {
      const field = item[key];
      if (field?.module !== 'general') return false;

      if (key === 'Registration_Type') return true; // Always show Registration Type

      const regType = this.dynamicForm.get('Registration_Type')?.value;
      if (regType === 'ENT') return true;
      return (
        (this.isDocumentType === '001' && field?.reg_type === regType) ||
        (this.isDocumentType === '002' && regType === 'ENT')
      );
    });
  }

  // ------- New drag and drop methods

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileArray: File[] = Array.from(files);
      const pdfFiles = fileArray.filter(
        (file) =>
          file.type === 'application/pdf' ||
          file.name.toLowerCase().endsWith('.pdf')
      );

      const nonPdfFiles = fileArray.filter(
        (file) =>
          file.type !== 'application/pdf' &&
          !file.name.toLowerCase().endsWith('.pdf')
      );

      if (nonPdfFiles.length > 0) {
        this.showError(
          'Invalid File Type',
          `Only PDF files are allowed. Rejected: ${nonPdfFiles
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
      }

      if (pdfFiles.length > 0) {
        await this.processFiles(null, pdfFiles);
      }
    }
  }

  // Extract common file processing logic into a separate method
  private async processFiles(base64: string | null, fileArray: File[]) {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under the 25MB gateway limit
    this.resetErrors();

    // 1. Size validation
    const oversizedFiles = fileArray.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      this.showError(
        'File Too Large',
        `Files exceeding 15MB limit: ${oversizedFiles
          .map((f) => f.name)
          .join(', ')}. Please upload a smaller PDF so it can be processed within the gateway's size limits.`,
        'error'
      );
      return;
    }

    // 2. Security validation using shared service
    try {
      const securityResults = await Promise.all(
        fileArray.map((file) =>
          this.pdfSecurityService.validateAndSanitizePDF(file)
        )
      );

      const eSignedFiles = fileArray.filter(
        (_, index) => securityResults[index].isESigned === true
      );

      const maliciousFiles = fileArray.filter(
        (_, index) =>
          !securityResults[index].isValid && !securityResults[index].isESigned
      );

      if (eSignedFiles.length > 0) {
        this.securityError = true;
        this.showError(
          'Electronic Signature Detected',
          `File contains electronic signature: ${eSignedFiles
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
        return;
      }

      if (maliciousFiles.length > 0) {
        this.securityError = true;
        const errorDetails = maliciousFiles
          .map((file, idx) => {
            const fileIndex = fileArray.indexOf(file);
            return `• ${file.name}: ${securityResults[fileIndex].reason}`;
          })
          .join('\n');

        this.showError(
          'Security Threat Detected',
          `The following PDF(s) failed security validation:\n${errorDetails}`,
          'error'
        );
        return;
      }
    } catch (error) {
      console.error('Security validation error:', error);
      this.securityError = true;
      this.showError(
        'Validation Failed',
        'Unable to validate PDF security. Please try again.',
        'error'
      );
      return;
    }

    // 3. Generate secure preview
    if (fileArray.length > 0) {
      this.safePreviewContent =
        await this.pdfSecurityService.generateSecurePreview(fileArray[0]);
    }

    // 4. All validations passed
    this.fileSizeError = false;
    this.signatureError = false;
    this.securityError = false;

    // Close the Upload Document bootstrap modal
    if (this.closeUploadPopupBtn?.nativeElement) {
      this.closeUploadPopupBtn.nativeElement.click();
    }

    // Stage files and immediately display preview modal in upload mode
    this.stagedUploadFiles = [...fileArray];
    this.previewModalMode = 'upload';
    if (fileArray.length > 1) {
      this.activePreviewIndex = -1;
      this.previewFile = null;
      this.previewModalFiles = [...fileArray];
      this.previewFileName = fileArray.map(f => f.name).join(', ');
    } else {
      this.activePreviewIndex = 0;
      this.previewFile = fileArray[0];
      this.previewModalFiles = [fileArray[0]];
      this.previewFileName = fileArray[0].name;
    }
    this.previewModalVisible = true;
    this.cdr.detectChanges();
  }
  removeFile() {
    this.fileName = '';
    // Reset file input
    const fileInput = document.getElementById(
      'upload_file'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  private resetErrors() {
    this.fileSizeError = false;
    this.securityError = false;
    this.chooseFile = false;
  }

  // === Cloud upload Methods ===

  // --- Google Drive Methods ---

  openGoogleDrive() {
    this.showGoogleDriveModal = true;
  }

  onGoogleDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      // console.error('Received empty file:', event.fileName);
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    if (this.uploadFiles.length === 0) {
      this.fileName = event.fileName;
      this.base64Data = event.base64;
    } else {
      this.fileName = this.fileName + ', ' + event.fileName;
    }

    this.processFiles(event.base64, [event.file]);
    // console.log('Google Drive file selected:', event.fileName);
  }

  onGoogleDriveModalClosed() {
    this.showGoogleDriveModal = false;
  }
  // --- End Google Drive Methods ---

  // --- Link Upload Methods ---
  openLink() {
    this.closeUploadPopupBtn.nativeElement.click();
    this.showLinkModal = true;
  }

  onLinkFileSelected(event: { file: File; base64: string; fileName: string }) {
    // Check if file is already selected
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    // Check if file is empty
    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Update the fileName display
    if (this.uploadFiles.length === 0) {
      this.fileName = event.fileName;
    } else {
      this.fileName = this.fileName + ', ' + event.fileName;
    }

    // Show the filename in the UI
    this.showFileName = true;
    this.chooseFile = false;

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from URL`,
    });

    console.log('Link file selected:', event.fileName);
  }

  onLinkModalClosed() {
    this.showLinkModal = false;
    console.log('Link modal closed');
  }

  // --- End Link Upload Methods ---

  // --- Dropbox Methods ---
  openDropbox() {
    // this.closeUploadPopupBtn.nativeElement.click();
   if (!this.dropboxEnabled) return;
    this.showDropboxModal = true;
  }

  onDropboxFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    console.log('Dropbox file selected:', event.fileName);
  }

  onOneDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    // Check if file is already selected
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    // Check if file is empty
    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    console.log('Dropbox file selected:', event.fileName);
  }

  onDropboxModalClosed() {
    this.showDropboxModal = false;
  }

  // --- End Dropbox Methods ---

  // --- OneDrive Methods ---
  openOneDrive() {
    this.showOneDriveModal = true;
    console.log('Opening OneDrive modal...');
  }
  onOneDriveModalClosed() {
    this.showOneDriveModal = false;
    console.log('OneDrive modal closed');
  }
  // --- End OneDrive Methods ---
  private async extractPdfInfoOnly(arrayBuffer: ArrayBuffer): Promise<void> {
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const totalPages = pdfDoc.getPageCount();

    console.log(`Processing PDF with ${totalPages} pages`);

    this.pageHeight = [];
    this.pageWidth = [];

    for (let i = 0; i < totalPages; i++) {
      const page = pdfDoc.getPage(i);
      const pageHeight = Math.round(page.getHeight());
      const pageWidth = Math.round(page.getWidth());

      this.pageHeight.push(pageHeight);
      this.pageWidth.push(pageWidth);
    }

    this.mergedPages = totalPages;
  }
  getTotalFileSize(): string {
     if (!this.uploadFiles || this.uploadFiles.length === 0) {
      return '0 B';
    }
    const totalBytes = this.uploadFiles.reduce(
      (sum, file) => sum + file.size,
      0
    );

    if (totalBytes < 1024) {
      return `${totalBytes} B`;
    } else if (totalBytes < 1024 * 1024) {
      return `${(totalBytes / 1024).toFixed(2)} KB`;
    } else {
      return `${(totalBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  }

  onReferencePaste(event: ClipboardEvent): void {
    if (!this.enableRefIdField) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const sanitized = clipboardData.replace(/[^a-zA-Z0-9_-]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = input.value.slice(0, start) + sanitized + input.value.slice(end);
    this.productDetails.get('referenceNumber')?.setValue(newValue);
  }
}
